export enum DownloadCalculationPDFErrorCodes {
  DOWNLOAD_CALCULATION_PDF_COMPANY_NOT_FOUND = 'DOWNLOAD_CALCULATION_PDF_COMPANY_NOT_FOUND',
  DOWNLOAD_CALCULATION_PDF_FOOTPRINT_NOT_FOUND = 'DOWNLOAD_CALCULATION_PDF_FOOTPRINT_NOT_FOUND',
  DOWNLOAD_CALCULATION_PDF_FOOTPRINT_NOT_PUBLISHED = 'DOWNLOAD_CALCULATION_PDF_FOOTPRINT_NOT_PUBLISHED',
  DOWNLOAD_CALCULATION_PDF_FOOTPRINT_EXISTS_ONLY_FOR_CALCULATION_METHOD = 'DOWNLOAD_CALCULATION_PDF_FOOTPRINT_EXISTS_ONLY_FOR_CALCULATION_METHOD',
  DOWNLOAD_PDF_FAILED_TO_GET_FILE = 'DOWNLOAD_PDF_FAILED_TO_GET_FILE',
}

export const DownloadCalculationPDFErrorCodesTranslationKeyMap = {
  [DownloadCalculationPDFErrorCodes.DOWNLOAD_CALCULATION_PDF_COMPANY_NOT_FOUND]: 'companyNotFound',
  [DownloadCalculationPDFErrorCodes.DOWNLOAD_CALCULATION_PDF_FOOTPRINT_NOT_FOUND]:
    'footprintNotFound',
  [DownloadCalculationPDFErrorCodes.DOWNLOAD_CALCULATION_PDF_FOOTPRINT_NOT_PUBLISHED]:
    'footprintNotPublished',
  [DownloadCalculationPDFErrorCodes.DOWNLOAD_CALCULATION_PDF_FOOTPRINT_EXISTS_ONLY_FOR_CALCULATION_METHOD]:
    'pdfExistsForCalculationOnly',
  [DownloadCalculationPDFErrorCodes.DOWNLOAD_PDF_FAILED_TO_GET_FILE]: 'pdfNotFound',
};
